import prod from './prod.json';
import test from './test.json';

module.exports = process.env.NODE_ENV.toLowerCase() === 'production' ? prod : test;
